import React from 'react';

import { IItem, MenuObject } from '@rbi-ctg/menu';
import { MenuObjectTypes } from 'enums/menu';
import { ProductWizardStep, UserSelectionModifierSlotMap } from 'state/product-wizard-v2/types';

import { ProductAddToCartCta } from './product-add-to-cart-cta/product-add-to-cart-cta';
import { ProductComboCta } from './product-combo-cta';
import { ProductConfirmEditOrderChanges } from './product-confirm-edit-order-changes';
import { ProductPickerCta } from './product-picker-cta';

interface IProductCtaProps {
  currentStep: ProductWizardStep;
  menuObject: MenuObject;
  modifierSelections?: UserSelectionModifierSlotMap;
  selectedItem?: IItem;
}

export const ProductCta = ({
  currentStep,
  menuObject,
  modifierSelections,
  selectedItem,
}: IProductCtaProps) => {
  const menuObjectType = menuObject._type;

  if (currentStep === ProductWizardStep.ProductEditOrder) {
    return (
      <ProductConfirmEditOrderChanges
        modifierSelections={modifierSelections}
        selectedItem={selectedItem}
      />
    );
  }

  if (currentStep === ProductWizardStep.ProductReview) {
    return <ProductAddToCartCta modifierSelections={modifierSelections} />;
  }

  switch (menuObjectType) {
    case MenuObjectTypes.ITEM:
      return <ProductAddToCartCta modifierSelections={modifierSelections} />;
    case MenuObjectTypes.COMBO:
      return (
        <ProductComboCta
          currentStep={currentStep}
          modifierSelections={modifierSelections}
          selectedItem={selectedItem}
        />
      );
    case MenuObjectTypes.PICKER:
      return (
        <ProductPickerCta selectedItem={selectedItem} modifierSelections={modifierSelections} />
      );
    default:
      return null;
  }
};
